/**
 * @Author: zpc
 * @Description:
 * @DateTime: Created in 2021-11-16 08:47:06
 */

 import * as Vue from 'vue-tsx-support';
 import { Component, Prop } from 'vue-property-decorator';
 import 'vue-tsx-support/enable-check';
 import Modal from 'src/types/iview/Modal';
 import Button from 'src/types/iview/Button';
 import Input from 'src/types/iview/Input';
 import { Toast } from 'src/util/toast';
 import { modalFactory } from 'src/util/vueExtend';
 import DiskConfigApi, { DiskConfigDOI } from './api/diskConfigApi';
 import EnumOperates from 'src/enums/enumOperates';
 import { Integer } from 'src/types/base';
 import InputNumber from 'src/types/iview/InputNumber';
 import EntitySelect from 'src/components/SelectCustom/entitySelect';
 import EnumEntity from 'src/enums/enumEntity';
 import CommonSelect from 'src/components/SelectCustom/commonSelect';
 import EnumDiskBank from 'src/enums/enumDiskBank';
 import IconCustom from 'src/components/icon/iconCustom';
 import EnumCloud from 'src/enums/EnumCloud';
 
 export namespace OperateDiskVOI {
     export interface PropsI {
         operate: string;
         data?: DiskConfigDOI.RowDataI;
 
         saveSuccess?(): void;
 
         cancel?(): void;
     }
 
     export interface FormDataI {
         dvr_id?: Integer;
         id?: Integer;
         name: string;
         device_id: Integer;
         device_name: string;
         channel_total_count: Integer;
         type:Integer;  // 1萤石云  2乐橙云  3 本地监控
         username: string;
         password: string;
         dvr_url: string;
         brand_type: Integer; // 所属品牌：（0大华1海康新2海康旧）
         deviceserial: string;
         validdatecode: string;
         nvr_user_id: Integer;
         nvr_user_name: string;
     }
 }
 
 @Component
 class OperateDiskModal extends Vue.Component<OperateDiskVOI.PropsI> {
     @Prop({
         type: Function,
     })
     cancel!: () => void;
 
     @Prop({
         type: Object,
     })
     data?: DiskConfigDOI.RowDataI
 
     @Prop({
         type: String,
     })
     operate!: string;
 
     @Prop({
         type: Function,
     })
     saveSuccess!: () => void;
 
     visible: boolean = false;
 
     loading: boolean = false;
 
     formData: OperateDiskVOI.FormDataI = {
         name: '',
         username: '',
         password: '',
         dvr_url: '',
         device_name: '',
         device_id: null,
         brand_type: null,
         channel_total_count: null,
         type:null,  // 1萤石云  2乐橙云  3 本地监控
         deviceserial: "",
         validdatecode: "",
         nvr_user_id: null,
         nvr_user_name: "",
     };
     rules: any = {
         name: [{ required: true, message: '请输入名称', trigger: 'change' }],
     };
 
     close() {
         this.cancel && this.cancel();
         this.closeModal();
     }
 
     closeModal() {
         this.visible = false;
         this.$emit('close', false);
     }
 
     async save() {
         if (!(await this.$validate('formValidate'))) {
             return;
         }
         let res;
         this.loading = true;
         let params = {
             ...this.formData,
         };
         switch (this.operate) {
             case EnumOperates.Add.getName():
                 res = await DiskConfigApi.add(params);
                 break;
             case EnumOperates.Update.getName():
                 params.dvr_id = this.data!.id
                 res = await DiskConfigApi.update(params);
                 break;
         }
         this.loading = false;
         let { code } = res;
         if (code === 0) {
             Toast.success(this.operate + '成功');
             this.saveSuccess();
             this.closeModal();
         }
     }
     mounted() {
         if(this.operate === EnumOperates.Update.getName()) {
             this.formData = this.data!
         }
     }
     render(h) {
         return (
             <Modal title={this.operate + '监控'} width="800" v-model={this.visible} mask-closable={false} on-on-cancel={this.close}>
                 <i-form ref="formValidate" labelWidth={100} model={this.formData} rules={this.rules} style="width:80%">
                     <form-item label="云端类型" prop="type" required style="display: inline-block;width:45%" type="number">
                         <CommonSelect dataSource={EnumCloud.getList()} v-model={this.formData.type} on-change={() => {
                             this.formData.nvr_user_id = null;
                             this.formData.deviceserial= "";
                             this.formData.validdatecode= "";
                         }} />
                     </form-item>
                     <form-item label="监控名称" prop="name" required style="display: inline-block;width:45%">
                         <Input v-model={this.formData.name} placeholder="请输入" />
                     </form-item>
                     <form-item label="站点" prop="device_id" required style="display: inline-block;width:45%" type="number">
                        <EntitySelect type={EnumEntity.Station.getId()} v-model={this.formData.device_id}  />
                     </form-item>
                     <form-item label="通道总数" prop="channel_total_count" required style="display: inline-block;width:45%" type="number">
                         <InputNumber v-model={this.formData.channel_total_count} placeholder="请输入" />
                     </form-item>
                     <form-item v-if={this.formData.type==3} label="硬盘机账号" prop="username" required={this.formData.type==3} style="display: inline-block;width:45%">
                         <Input v-model={this.formData.username} placeholder="请输入" />
                     </form-item>
                     <form-item v-if={this.formData.type==3} label="硬盘机密码" prop="password" required={this.formData.type==3} style="display: inline-block;width:45%">
                         <Input v-model={this.formData.password} placeholder="请输入" type="password" >
                             <IconCustom type="icon-jianpan" slot="suffix" color="#fff"/>
                         </Input>
                     </form-item>
                     <form-item v-if={this.formData.type==3} label="路径" prop="dvr_url" required={this.formData.type==3} style="display: inline-block;width:45%">
                         <Input v-model={this.formData.dvr_url} placeholder="请输入id+端口" >
                         </Input>
                     </form-item>
                     <form-item v-if={this.formData.type==3} label="监控品牌" prop="brand_type" required={this.formData.type==3} style="display: inline-block;width:45%" type="number">
                         <CommonSelect dataSource={EnumDiskBank.getList()} v-model={this.formData.brand_type}  />
                     </form-item>
                     <form-item v-if={this.formData.type==1 || this.formData.type==2} label="视频密钥账户" prop="nvr_user_id" required={this.formData.type==1 || this.formData.type==2} type="number">
                         <EntitySelect type={EnumEntity.VideoKey.getId()} searchParams={{"type": this.formData.type}} v-model={this.formData.nvr_user_id}/>
                     </form-item>
                     <form-item v-if={this.formData.type==1 || this.formData.type==2} label="序列号" prop="deviceserial" required={this.formData.type==1 || this.formData.type==2}>
                         <Input v-model={this.formData.deviceserial} placeholder="请输入" />
                     </form-item>
                     <form-item v-if={this.formData.type==1 || this.formData.type==2} label="验证码" prop="validdatecode" required={this.formData.type==1 || this.formData.type==2}>
                         <Input v-model={this.formData.validdatecode} placeholder="请输入" />
                     </form-item>
                 </i-form>
                 <div slot="footer">
                     <Button type="primary" ghost on-click={this.close}>
                         取消
                     </Button>
                     <Button type="primary" on-click={this.save} loading={this.loading}>
                         保存
                     </Button>
                 </div>
             </Modal>
         );
     }
 }
 
 export default function alertOperateDiskModal(operate: string, data?: DiskConfigDOI.RowDataI): Promise<boolean> {
     return new Promise((resolve, reject) => {
         modalFactory<OperateDiskVOI.PropsI>(OperateDiskModal)({
             data,
             operate,
             saveSuccess() {
                 resolve(true);
             },
             cancel() {
                 resolve(false);
             },
         });
     });
 }
 